/** @jsx jsx */
import { jsx } from "theme-ui"
import Tw from '../images/tw.png'
import Ig from '../images/ig.png'
import Fb from '../images/fb.png'
import { ExternalLink } from "./link"

const socials = [
    ['https://www.facebook.com/BusinessandArtsNL/', Fb],
    ['https://www.instagram.com/businessandartsnl/', Ig],
    ['https://twitter.com/BizArtsNL', Tw],
]

function Socials({}) {
    return (
        <div sx={{display: 'flex',}}>
            {socials.map(([href, src]) => <ExternalLink key={href} href={href}>
                <img sx={{mr: 3}} width="33" height="33" src={src} />
            </ExternalLink>)}
        </div>
    )
}

export default Socials